import { useState } from "react"
import { Box, IconButton } from "@mui/material"
import StopIcon from "@mui/icons-material/Stop"
import { styled, keyframes } from "@mui/system"

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const CircularContainer = styled(Box)(({ theme }) => ({
    position: "relative",
    width: 55,
    height: 55,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
}))

const AnimatedCircle = styled("div")(({ theme }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: "50%",
    border: "4px solid transparent",
    borderTopColor: "#EA297C",
    animation: `${spin} 1s linear infinite`,
}))

const StyledIconButton = styled(IconButton)(({ theme }) => ({
    backgroundColor: "#EA297C",
    color: "white",
    width: 40,
    height: 40,
    "&:hover": {
        backgroundColor: "#d1246e",
    },
}))

const CircularButton = ({ onClickStop }) => {
    const [isAnimating, setIsAnimating] = useState(true)

    const stopTasking = () => {        
            setIsAnimating(false);
            onClickStop(); // Vérifie et appelle la fonction
    };
        

    return (
        <CircularContainer >
            {isAnimating && <AnimatedCircle />}
            <StyledIconButton onClick={stopTasking} aria-label="stop">
                <StopIcon style={{ fontSize: 30 }} />
            </StyledIconButton>
        </CircularContainer>
    )
}

export default CircularButton

